<template>
    <div class="main-page-wrap">
        <template v-if="showedInfo">
            <form v-if="answers.length" class="mt-4" @submit.prevent="onSubmit">

                <div v-for="(cat, i) in questions" :key="i" class="mb-4">
                    <div class="subheading mb-3">
                        <span>{{i + 1}}) </span>
                        <span>{{cat.text}}</span>
                    </div>
                    <question-radio horizontal class="ml-4 answers big5__radio" v-model="answers[i].value" :id="cat.id" :error="answers[i].error" :items="answers[i].items"></question-radio>
                </div>

                <div class="text-xs-center">
                    <v-btn color="success" :loading="pending" type="submit">Продолжить</v-btn>
                </div>
            </form>
            <div class="text-xs-center" v-else>
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </div>
        </template>

        <template v-else>
            <info-block @success="showedInfo = true" :title="infoData.title" :content="infoData.content"></info-block>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import QuestionRadio from '@/components/question/radio.vue'
    import VueScrollTo from 'vue-scrollto'
    import InfoBlock from './info'
    import InfoData from './data'

    export default {
        components: {
            QuestionRadio,
            InfoBlock
        },
        data () {
            return {
                pending: false,
                showedInfo: false,
                answers: []
            }
        },
        props: {
            options: Object
        },
        computed: {
            ...mapGetters('questions', ['questions']),
            sendData () {
                return this.answers.map(item => {
                    return {
                        quest: item.id,
                        text: item.value + ''
                    }
                })
            },
            infoData () {
                return InfoData
            }
        },
        mounted () {
            this.$store.dispatch('questions/init', {
                stage: this.options.stage
            }).then(() => {
                if (!this.questions.length) {
                    this.$store.dispatch('testing/next')
                } else {
                    this.answers = this.createAnswers()
                }
            })
        },
        methods: {
            checkErrors () {
                let errors = 0
                this.answers.forEach(item => {
                    item.error = !item.value
                    if (item.error) {
                        errors++
                    }
                })
                return errors
            },
            onSubmit () {
                if (this.pending) return

                if (this.checkErrors()) {
                    return VueScrollTo.scrollTo(document.querySelector('body'), 1500)
                }

                this.pending = true

                this.$store.dispatch('questions/answers', this.sendData)
                    .then(() => {
                        this.pending = false
                        this.$store.dispatch('testing/next')
                    })
                    .catch(() => (this.pending = false))
            },
            createAnswers () {
                return this.questions.map(question => {
                    return {
                        id: question.id,
                        value: '',
                        error: false,
                        items: [
                            {answer: 'Полностью не согласен', value: 1},
                            {answer: 'Не согласен', value: 2},
                            {answer: 'Отношусь нейтрально', value: 3},
                            {answer: 'Скорее согласен, чем нет', value: 4},
                            {answer: 'Полностью согласен', value: 5}
                        ]
                    }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    /deep/ .answers .is-horizontal .input-group__input > .radiobutton {
        min-width 170px
        align-items center
    }
    >>> .big5__radio .is-medium {
        width auto!important
    }
</style>
